<template>
  <div>
    <user-popup
      :show="isShowUserPopup"
      :currentAgentData="currentAgentData"
      @finish="onfinish"
    ></user-popup>
    <sales-persons-popup
      :show="isShowSalesPersonsPopup"
      :agentId="agentId"
      @finish="onfinish"
    ></sales-persons-popup>
    <agent-segment-popup
      :show="isShowAgentSegmentPopup"
      :agentId="agentId"
      :agentName="agentName"
      @finish="onfinish"
    ></agent-segment-popup>
    <div class="flex justify-end my-5 gap-5">
      <vs-button
        @click.prevent="downloadExcelFile"
        class="bg_m_blue"
        :disabled="excelFileLoading"
        v-if="$tabHasPermission('GetAgentsWithExcelFile')"
      >
        <div class="flex gap-2 items-center">
          <span>{{ $t("DownloadExcelFile") }}</span>
          <img
            v-if="excelFileLoading"
            src="@/assets/images/loading.gif"
            class="w-6 h-6"
          />
        </div>
      </vs-button>
      <filter-button @click="toggleShowFilters" />
    </div>
    <form v-if="showFilters" class="filter-form">
      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
          <vs-input
            class="inputx mb-4"
            v-model="gridSearchData.Name"
            :label="$t('AgentName')"
          />
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full">
          <label class="vs-select--label mb-1">{{ $t("AgentType") }}</label>
          <v-select
            label="name"
            :options="customers"
            v-model="gridSearchData.agentTypeQuery"
            :reduce="(x) => x.id"
            :clearable="false"
            ref="agentType"
            dir="rtl"
          >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mt-6">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitFilter()"
            >{{ $t("SubmitFilter") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="reset-btn"
            @click.prevent="resetForm"
            >{{ $t("ResetFilter") }}</vs-button
          >
        </div>
      </div>
    </form>
    <data-grid
      ref="grid"
      stripe
      v-has-permission="permission240"
      :data-source="gridDataSource"
      :search-data="gridSearchData"
      :columns="[
        { title: $t('Name') },
        { title: $t('AgentID') },
        { title: 'کد نماینده' },
        {
          title: $t('SocialSecurityNumber') + ' / ' + $t('CompanyNationalId'),
        },
        { title: $t('PartyType') },
        { title: $t('Branch') },
        { title: $t('Action') },
      ]"
    >
      <template slot-scope="{ row }">
        <td style="width: 16%">
          <span v-if="row.partyType == 'AgentIndividual'">
            {{ row.firstName }} {{ row.lastName }}
          </span>
          <span v-if="row.partyType == 'AgentLegal'">
            {{ row.companyName }}
          </span>
        </td>
        <td style="width: 8%">
          {{ row.id }}
        </td>
        <td style="width: 8%">
          {{ row.code }}
        </td>
        <td style="width: 15%">
          <span v-if="row.socialSecurityNumber">
            {{ row.socialSecurityNumber }}
          </span>
          <span v-if="row.companyNationalId"> {{ row.companyNationalId }}</span>
          <span v-if="!row.socialSecurityNumber && !row.companyNationalId"
            >-</span
          >
        </td>
        <td style="width: 10%; direction: ltr">
          <span v-if="row.partyType == 'AgentIndividual'">
            {{ $t("Individual") }}
          </span>
          <span v-if="row.partyType == 'AgentLegal'">
            {{ $t("Legal") }}
          </span>
        </td>
        <td style="width: 8%; direction: ltr">
          <span v-if="row.agentBranchInfo == 1">
            <router-link
              :to="{
                path: '/Agents/CreateBranch/' + row.id,
                query: {
                  breadcrumbNameManual: {
                    persianTitleParent: row.companyName,
                  },
                },
              }"
            >
              <vs-button
                icon="icon-plus"
                color="primary"
                type="border"
                icon-pack="feather"
                class="custom-border-btn"
                @click="onShowAddBranch(row)"
                v-has-permission="permission878"
                >{{ $t("AddBranch") }}</vs-button
              >
            </router-link>
          </span>
          <span v-else-if="row.agentBranchInfo == 2">شعبه</span>
          <span v-else>--- </span>
        </td>
        <td style="width: 30%; direction: ltr">
          <div
            class="w-full h-full flex flex-wrap items-center justify-center gap-y-2"
          >
            <span v-if="row.partyType == 'AgentIndividual'">
              <router-link
                :to="{
                  path: '/Agents/EditIndividual/' + row.id,
                  query: {
                    ownerUserId: row.agentOwnerQuery.ownerId,
                    ownerUserName: row.agentOwnerQuery.agentOwnerName,
                  },
                }"
              >
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  v-has-permission="permission81"
                ></vs-button>
              </router-link>
            </span>
            <span v-else-if="row.partyType == 'AgentLegal' && row.id != 0">
              <router-link
                :to="{
                  path: '/Agents/EditLegal/' + row.id,
                  query: {
                    ownerUserId: row.agentOwnerQuery.ownerId,
                    typeAgent: row.agentBranchInfo,
                  },
                }"
              >
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  v-has-permission="permission81"
                ></vs-button>
              </router-link>
            </span>
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-eye"
              class="custom-border-btn ml-2"
              @click="onShowAgentSegment(row)"
              v-has-permission="permission1319"
              >{{ $t("Segment") }}</vs-button
            >
            <router-link
              :to="{
                path: '/AgentQuotas/' + row.id,
                query: {
                  AgentName: row.firstName
                    ? row.firstName + ' ' + row.lastName
                    : row.companyName,
                },
              }"
              style="margin: 0"
            >
              <vs-button
                icon="icon-eye"
                color="primary"
                type="border"
                icon-pack="feather"
                class="custom-border-btn"
                v-has-permission="permission80"
                >{{ $t("Quota") }}</vs-button
              >
            </router-link>
            <vs-button
              icon="icon-plus"
              color="primary"
              type="border"
              icon-pack="feather"
              class="custom-border-btn"
              @click="onShowAddUser(row)"
              v-has-permission="permission678"
              >{{ $t("AssignUsers") }}</vs-button
            >
            <vs-button
              icon="icon-eye"
              color="primary"
              type="border"
              icon-pack="feather"
              class="custom-border-btn"
              @click="onShowSalesPersons(row.id)"
              v-has-permission="permission280"
              >{{ $t("SalesPersons") }}</vs-button
            >
          </div>
        </td>
      </template>
    </data-grid>
  </div>
</template>
<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}

.filter-form {
  border-top: 1px dashed #ddd;
  padding-top: 0.5rem;
}

.filter-form
  .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0.5rem 2rem;
}
</style>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import FilterButton from "@/components/buttons/FilterButton.vue";
import UserPopup from "./UserPopup.vue";
import SalesPersonsPopup from "./SalesPersonsPopup.vue";
import AgentSegmentPopup from "./AgentSegmentPopup.vue";
import utils from "@/assets/utils/index";

export default {
  data() {
    return {
      permission240: "GetAllByAgentInfo",
      permission878: "AssignAgentLegalMember",
      permission81: "GetAgentRecipientsByOwnerIdInShipping|GetAgentById",
      permission280: "GetAllByOwnerId",
      permission678: "AssignAgentLegalMember",
      permission80: "GetAllSaleAgentQuota",
      permission1319: "GetAllAgentSegmentWithSalePersonInfo",

      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/AgentsInfoQuery",
      },
      gridSearchData: {
        AgentState: 1,
      },
      customers: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
      isShowUserPopup: false,
      isShowAgentSegmentPopup: false,
      isShowAgentBranchPopup: false,
      isShowSalesPersonsPopup: false,
      currentAgentData: {},
      agentId: "",
      agentName: "",
      showFilters: false,
      excelFileLoading: false,
    };
  },
  methods: {
    ...mapActions({
      exportAgents: "excel/exportAgents",
    }),

    downloadExcelFile() {
      this.excelFileLoading = true;
      var params = utils.toQueryString(this.gridSearchData);
      this.exportAgents(params)
        .then(() => {
          this.excelFileLoading = false;
        })
        .catch(() => {
          this.excelFileLoading = false;
        });
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.$refs.agentype.clearSelection();
      }, 0);
    },
    onfinish() {
      this.isShowUserPopup = false;
      this.isShowSalesPersonsPopup = false;
      this.isShowAgentSegmentPopup = false;
      this.isShowAgentBranchPopup = false;
    },
    onShowAddUser(agentData) {
      this.isShowUserPopup = true;
      this.currentAgentData = agentData;
    },
    onShowSalesPersons(agentId) {
      this.isShowSalesPersonsPopup = true;
      this.agentId = agentId;
    },
    onShowAgentSegment(data) {
      this.agentId = data.id;
      this.agentName = data.name;
      this.isShowAgentSegmentPopup = true;
    },
    onShowAddBranch(data) {
      this.agentId = data.id;
      this.isShowAgentBranchPopup = true;
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    UserPopup,
    AgentSegmentPopup,
    SalesPersonsPopup,
    FilterButton,
  },
};
</script>
